import { Box, DialogContent, Divider } from "@mui/material";
import UserTag from "@/modules/user/components/user-tag";
import CustomLinearProgress from "@/modules/common/components/ui/linear-progress";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { TargetUserDTO } from "@/modules/targetsv2/dtos/index.v2";
import { MonthlySummary, TargetInteface } from "@/modules/targetsv2/types";

interface EditQuarterTargetFormProps {
  data: MonthlySummary[];
}

const MonthlySummaryTable: React.FC<EditQuarterTargetFormProps> = ({
  data,
}) => {
  const screen = useScreenSize();

  const renderVerticalDivider = () => {
    if (!screen.isMobile) {
      return (
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderBottomWidth: 1,
            borderColor: "darkGray",
          }}
        />
      );
    }
  };

  return (
    <DialogContent sx={{ p: 0 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            pl: screen.isMobile ? 0 : 2,
            pr: screen.isMobile ? 0 : 4,
          }}
        >
          <Box
            sx={{
              flex: screen.isMobile ? 1 : 2,
              fontSize: "10px",
              minWidth: screen.isMobile ? "38vw" : "30%",
              maxWidth: screen.isMobile ? "42vw" : "30%",
            }}
          >
            Users
          </Box>
          {renderVerticalDivider()}
          <Box sx={{ flex: 1, fontSize: "10px" }}>Achived</Box>

          {renderVerticalDivider()}
          <Box sx={{ flex: 1, fontSize: "10px" }}>Target</Box>
        </Box>
        <Divider
          sx={{
            borderBottomWidth: 1,
            borderColor: "darkGray",
          }}
        ></Divider>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          {data.map(({ user, team, personal, hasTeam }, index) => {
            return (
              <RowView
                user={user}
                data={hasTeam ? team : personal}
                index={index}
                key={index}
              />
            );
          })}
        </Box>
      </Box>
    </DialogContent>
  );
};

const RowView = ({
  data,
  index,
  user,
}: {
  data: TargetInteface;
  index: number;
  user: TargetUserDTO;
}) => {
  const screen = useScreenSize();

  const formatPercentage = (percentage: number) => {
    //has no decimal
    if (Number.isInteger(percentage)) {
      return percentage;
    } else {
      //return first decimal
      return percentage.toFixed(1);
    }
  };

  const renderVerticalDivider = () => {
    if (!screen.isMobile) {
      return (
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderBottomWidth: 1,
            borderColor: "darkGray",
          }}
        />
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: screen.isMobile ? 0.2 : 1,
        backgroundColor: index % 2 === 0 ? "#FFF" : "#F3FAFF",
        py: "12px",
        pl: screen.isMobile ? 0 : 2,
        pr: screen.isMobile ? 0 : 4,
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          flex: screen.isMobile ? 1 : 2,
          fontSize: "10px",
          alignContent: "center",
          minWidth: screen.isMobile ? "38vw" : "30%",
          maxWidth: screen.isMobile ? "42vw" : "30%",
        }}
      >
        <UserTag name={user.name} color={user.color} />
      </Box>
      {renderVerticalDivider()}

      {screen.isMobile ? (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <Box
            sx={{
              flex: 1,
              fontSize: "10px",
              alignContent: "center",
            }}
          >
            {data?.achieved?.toLocaleString() + " " + "EGP"}
            {/* percentage */} (
            {formatPercentage(data?.progressPercentage * 100) + "%"}
            )
            <CustomLinearProgress
              value={data.progressPercentage * 100}
              color={data.progressColor}
            />
          </Box>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              flex: 1,
              fontSize: "10px",
              alignContent: "center",
            }}
          >
            {data?.achieved?.toLocaleString() + " " + "EGP"}
            {/* percentage */} (
            {formatPercentage(data?.progressPercentage * 100) + "%"}
            )
            <CustomLinearProgress
              value={data.progressPercentage * 100}
              color={data.progressColor}
            />
          </Box>
        </>
      )}

      {renderVerticalDivider()}
      {screen.isMobile ? (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <Box
            sx={{
              flex: 1,
              fontSize: "10px",
              alignContent: "center",
              pl: screen.isMobile ? 2 : 0,
            }}
          >
            {data.target.toLocaleString() + " " + "EGP"}
          </Box>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              flex: 1,
              fontSize: "10px",
              alignContent: "center",
              pl: screen.isMobile ? 2 : 0,
            }}
          >
            {data.target.toLocaleString() + " " + "EGP"}
          </Box>
        </>
      )}
    </Box>
  );
};
export default MonthlySummaryTable;
